/* eslint-disable */
export default {
  saveLog: 'Salvar',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
